import axios from 'axios';
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import StatusLine from './StatusLine'
import Divider from './Divider';
import { withRouter } from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CircularProgress from '@material-ui/core/CircularProgress';
import RmaLogic from '../Logic/Logic.ts'
import DropDown from './DropDown';

class Status extends Component {
    static propTypes = {
        lines: PropTypes.object,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        setDialogState: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            lines: [],
            reshipReasons: [],
            reshipOrder: false,
            reshipReasonId: '0',
            canReshipOrder: false,
            isInternational: false,
            logic: new RmaLogic(),
        }
    }


    componentDidMount() {
        let rawOrderInfo = localStorage.getItem('orderInfo') || ''
        if (rawOrderInfo) {
            let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
            this.setState({ canReshipOrder: orderInfo.canReshipOrder })
            this.setState({ isInternational: orderInfo?.isInternational })
            if (orderInfo.lines) {
                this.setState({ reshipReasons: orderInfo.reshipReasons ?? [] })
                this.setState({ lines: orderInfo.lines })
            }
        }
        else {
            this.props.history.replace('/pages/returns')
        }

        window.scrollTo(0, 0)
    }

    handleCheckChange = name => event => {
        var nv = event.target.checked
        let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
        orderInfo.reshipOrder = nv
        this.setState({ reshipOrder: nv })
        localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
    };

    showLoading = (msg) => {
        this.props.setDialogState(
            true,
            msg,
            <CircularProgress />,
            <></>,
            false,
            false)
    }

    hideLoad = () => {
        this.props.setDialogState(
            false,
            '',
            <></>,
            <></>,
            false,
            false)
    }

    reshipOrder = async () => {
        this.showLoading('Building your reship order.')
        let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')

        try {
            let req = {
                orderId: orderInfo.lines[0].orderId,
                reshipReasonId: this.state.reshipReasonId,
                lines: this.state.lines ?? [],
            }
            console.log(req)
            var retVal = (await axios.post('https://bos.braceability.com/api/ReturnBot/ReshipOrder', req))?.data;
            console.log(retVal)
            retVal.isReship = true;
            localStorage.setItem('buildReturnResult', JSON.stringify(retVal))
            this.hideLoad();
            this.props.history.replace('/pages/returns/results')

        } catch (error) {
            this.hideLoad();
            orderInfo.errorTitle = "Encountered problem(s) while duplicating your order."
            orderInfo.errorMessage = "Encountered problem(s) while duplicating your order."
            localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
            this.props.history.replace('/pages/returns/whoops')
        }
    }

    newSearch = () => {
        localStorage.setItem('orderInfo', '')
        this.props.history.replace('/pages/returns')
    }

    nextButtonClick = async () => {
        if (this.state.reshipOrder) {
            const isValid = (this.state.lines.filter(f => f?.isReship)?.length > 0) && (this.state?.reshipReasonId !== '0')
            if (isValid) {
                await this.reshipOrder()
            }  
            else {
                this.props.setDialogState(
                    true,
                    'You forgot something',
                    <Typography variant="h6" display="block" component="div">You can't proceed unless you select to reship at least one item and reship reason.</Typography>,
                    <></>,
                    false,
                    true, true
                )
            }
        }
        else {
            const validLines = this.state.lines.filter(f => f.hasEdits && f.isValid && (f.isReturn || f.isExchange))
            if (validLines?.length > 0) {
                this.props.history.push('/pages/returns/summary')
            }
            else {
                this.props.setDialogState(
                    true,
                    'You forgot something',
                    <Typography variant="h6" display="block" component="div"  >You can't proceed unless you select to return or exchange at least one item.</Typography>,
                    <></>,
                    false,
                    true, true
                )
            }
        }
    }

    render() {
        const lines = this.state.lines
        const canExchange = this.state?.lines?.some(line => line?.canExchange);
        return (
            <ErrorBoundary>
                {this.state.canReshipOrder &&
                    <Grid item>
                        <FormControlLabel style={{ color: 'red', paddingLeft: '15px' }}
                            control={
                                <Checkbox
                                    checked={this.state.reshipOrder}
                                    onChange={this.handleCheckChange('reshipOrder')}
                                    value="reshipOrder"
                                    color="primary"
                                />
                            }
                            label="Reship Order"
                        />
                    </Grid>
                }
                <Typography variant="h6" display="block" component="div">
                    Select item(s) to { this.state.reshipOrder ? 'reship': canExchange ? 'return or exchange' : 'return' }
                </Typography>
                {
                    this?.state?.reshipOrder && (
                        <DropDown 
                            name="reshipReasonId"
                            labelText="Reason for reship"
                            value={this?.state?.reshipReasonId}
                            onChange={(_) => (event)=> {
                                this.setState({reshipReasonId: event?.target?.value})
                            }}
                            helperText="Select a reason for reshipping the order">
                            <option disabled value="0">Choose an Option</option>
                            {this?.state?.reshipReasons?.map((reason, index) =>
                                <option key={index} value={reason.id}>{reason.reason}</option>
                            )}
                            <option value="-1">Reship</option>
                        </DropDown>
                    )
                }
                <List>
                    {lines.filter(f => f.productId !== 1).map((v, i) =>
                        <ListItem key={i} style={{ margin: 0, padding: 0 }}>
                            <StatusLine
                                line={v}
                                reshipOrder={this.state.reshipOrder}
                                setDialogState={this.props.setDialogState} />
                        </ListItem>
                    )}
                </List>

                {
                    this.state.isInternational && (
                        <>
                            <Divider />
                                <Grid container direction="row" justify="flex-start" alignItems="center"  >
                                    <Grid item>
                                        <div>Thank you for being a valued customer. While we do accept returns for a refund on eligible items, please note that <b>international customers are responsible for covering the return shipping costs</b> to BraceAbility. You can view our full <a target="_blank" rel="noopener noreferrer" href="https://www.braceability.com/pages/returns#international-return-policy"> return policy here.</a></div>
                                    </Grid>
                                </Grid>
                            <Divider />
                        </>
                    )
                }

                <Grid container direction="row" justify="flex-start" alignItems="center">
                    <Grid item>
                        <Button color="primary" variant="outlined" onClick={this.newSearch}>Search Another Order</Button>
                    </Grid>

                    <Grid item>
                        <Button color="primary" style={{ marginLeft: 5 }} variant="contained" onClick={this.nextButtonClick}>Next</Button>
                    </Grid>
                </Grid>
            </ErrorBoundary>
        )
    }
}

export default withRouter(Status)